import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import ReactDOM from 'react-dom';
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { appContext } from '../../../App'
import { invoiceItemControllerContext } from './InvoiceItemController'
import InvoiceController from '../invoice/InvoiceController'
import InvoiceItemFooterStyle from './css/InvoiceItemFooterStyle'
import ReceiptController from '../../receipt/receipt/ReceiptController'
import InvoiceListController from '../../invoice/invoicelist/InvoiceListController'
import { selectPaperSizeForm } from './forms/SelectPaperSizeForm'
import { dateYMD } from '../../utilities/utilities'

function InvoiceItemFooter() {
  const app = useContext(appContext)
  const invoiceItemController = useContext(invoiceItemControllerContext)
  const { invoice, deleteInvoice, getInvoiceById, saveInvoice } = invoiceItemController
  const setPaperSize = invoiceItemController.paperSize[1]
  const setContent = app.content[1]

  let userHaveFC = true
  if (app.client.signed_in !== 'admin') userHaveFC = app.client.signed_in.user_access.invoice_fc

  const showMessageBoxInvoiceNotFound = () => {
    const onClick = async () => {
      setContent(<InvoiceListController />)
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
    ReactDOM.render (
      <ModalWindow id='mw-parent' height='20' width='25' header='Invoice Not Found' footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>Invoice file/record no longer exist.</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickEdit = async (e) => {
    // Check if the invoice still available/exist
    const invoice_found = await getInvoiceById(app, invoice._id)

    const showMessageBox = (message) => {
      const onClick = async (button) => {
        if (button === 'Yes') {
          // Once again check if the invoice still available/exist
          const inv = await getInvoiceById(app, invoice._id, true)
          // Double check if the invoice still exist
          if (inv) {
            // inv.status = 'On Process'
            setContent(<InvoiceController invoice={inv} />)
          } else {
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
            showMessageBoxInvoiceNotFound()
            return // To avoid closing the messagebox unintentionally (see line of code just below)
          }
        }
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='45'
          width='45'
          header="Edit Record"
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div style={{color: 'red', padding: '5px 0'}}>Warning!</div>
              <div>{ message }</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn top-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (invoice_found) {
      // convert invoice_date first to a format that will be accepted buy our date control
      invoice_found.invoice_date = dateYMD(new Date(invoice.invoice_date))

      // Indicate the backend API that this action is edit
      invoice_found.action = 'edit'

      const onProcessInvoiceWarningMessage =
      <>
        You are trying to edit an "On Process" statused invoice.<br/>
        Please make sure this invoice is no longer active or open in other terminals.<br/>
        If you force it, you or somebody else who currently on it might lose some data or may experience unwanted behaviour on the invoice itself.
      </>

      if (invoice_found.status === 'On Process') showMessageBox(onProcessInvoiceWarningMessage)
      else { 
        invoice_found.status = 'On Process'
        setContent(<InvoiceController invoice={invoice_found} />)
      }
    } else showMessageBoxInvoiceNotFound()
  }

  const onClickDelete = async (e) => {
    // Check if the invoice still available/exist
    const invoice_found = await getInvoiceById(app, invoice._id)

    const showMessageBox = () => {
      const onClick = async (button) => {
        if (button === 'Yes') {
          const inv = await getInvoiceById(app, invoice._id, true)
          // Double check if the invoice still exist
          if (inv) {
            await deleteInvoice(app, invoice._id)
            setContent(<InvoiceListController />)
          } else {
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
            showMessageBoxInvoiceNotFound()
            return // To avoid closing the messagebox unintentionally (see line of code just below)
          }
        }
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header="Delete Record"
          height='30'
          width='35'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>
                You are about to delete this invoice<br/>
                All the item inside this invoice will be put back into the inventory as well.
              </div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }
    if (invoice_found) showMessageBox()
    else showMessageBoxInvoiceNotFound()
  }

  const onClickCheckout = async (e) => {
    // Check if the invoice still available/exist
    const invoice_found = await getInvoiceById(app, invoice._id)

    const showMessageBox = async () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header="Delete Record"
          height='30'
          width='35'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>This invoice was modified by other users during the process.</div>
              <div>It's either already checked-out, linked or modified to be unpaid.</div>
            </div>
            <div className='button-container'>
              <button onClick={() => setContent(<InvoiceListController />)} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (invoice_found) {
      // Check if invoice status is valid one
      if (invoice_found.status === 'On Process' || invoice_found.status === 'Unpaid') {
        //Will open another form or will render another view like pushing next page
        if (invoice_found.status === 'Unpaid') {
          invoice_found.status = 'On Process'
          await saveInvoice(app, invoice_found)
        }
        const receipt_for = {
          item_name: 'Invoice',
          item: invoice_found 
        }
        setContent(<ReceiptController receipt_for={receipt_for}/>)
      } else showMessageBox()
    } else showMessageBoxInvoiceNotFound()
  }

  const onClickPrint = async (e) => {
    // Check if the invoice still available/exist
    const invoice_found = await getInvoiceById(app, invoice._id)

    if (invoice_found) {
      const cbf = (res) => { setPaperSize(res) }
      selectPaperSizeForm(cbf)
    } else showMessageBoxInvoiceNotFound()
  }

  // Edit *************************
  const getEditButtonDisplay = () => (
    ((
      (invoice.status === 'Unpaid') ||
      ((invoice.status === 'On Process') && (invoice.invoice_particulars.length > 0)) ||
      ((invoice.status === 'Inactive') && (invoice.invoice_particulars.length > 0))
    ) && userHaveFC) ? 'inline-block' : 'none'
  )

  // Delete *************************
  const getDeleteButtonDisplay = () => (
    ((
      (invoice.status === 'Unpaid') ||
      (invoice.status === 'Inactive')
    ) && userHaveFC) ? 'inline-block' : 'none'
  )

  // Print *************************
  const getPrintButtonDisplay = () => (
    (
      (invoice.status === 'On Process') ||
      (invoice.status === 'Paid') ||
      (invoice.status === 'Unpaid') ||
      (invoice.status === 'Linked')
    ) ? 'inline-block' : 'none'
  )

  // Checkout *************************
  const getCheckoutButtonDisplay = () => (
    ((
      (invoice.status === 'Unpaid')
    ) && userHaveFC) ? 'inline-block' : 'none'
  )

  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='action-btn-container'>
          <button
            onClick={() => setContent(<InvoiceListController />)}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='undo-alt'/>&nbsp;<u>B</u>ack to Invoice's List
          </button>
          <button
            id='invoice-edit-button'
            style={{display: getEditButtonDisplay() }}
            onClick={onClickEdit}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='edit'/>&nbsp;<u>E</u>dit...
          </button>
          <button
            id='invoice-delete-button'
            style={{display: getDeleteButtonDisplay() }}
            onClick={onClickDelete}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='times'/>&nbsp;<u>D</u>elete...
          </button>
          <button
            id='invoice-print-button'
            style={{display: getPrintButtonDisplay() }}
            onClick={onClickPrint}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;<u>P</u>rint...
          </button>
          <button
            id='invoice-checkout-button'
            style={{display: getCheckoutButtonDisplay() }}
            onClick={onClickCheckout}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='coins'/>&nbsp;<u>C</u>heckout...
          </button>
        </div>
      </div>
      <InvoiceItemFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(InvoiceItemFooter)